export type SortDir = 'asc' | 'desc';

/**
 * Sort rows by a value accessor. Numbers compare numerically; everything else
 * compares as strings with numeric awareness (so "File 2" < "File 10", and ISO
 * dates yyyy-mm-dd sort chronologically). Returns a new array.
 */
export function sortRows<T>(rows: T[], dir: SortDir, getVal: (r: T) => string | number): T[] {
  const out = [...rows];
  out.sort((a, b) => {
    const va = getVal(a);
    const vb = getVal(b);
    const c =
      typeof va === 'number' && typeof vb === 'number'
        ? va - vb
        : String(va).localeCompare(String(vb), undefined, { numeric: true, sensitivity: 'base' });
    return dir === 'asc' ? c : -c;
  });
  return out;
}
